import { useState, useEffect } from 'react';
export function useAsync(operation) {
    const [result, setResult] = useState({ status: 'pending' });
    useEffect(() => {
        operation()
            .then((value) => setResult({ status: 'resolved', value }))
            .catch((error) => setResult({ status: 'rejected', error }));
    }, [operation]);
    return result;
}
//# sourceMappingURL=use-async.js.map